import { Component } from '@angular/core';
import { TabLinks } from '@montebravo.tech/design-system-navigation';

@Component({
    selector: 'app-wealth',
    templateUrl: './wealth-services.component.html',
    styleUrls: ['./wealth-services.component.scss'],
})
export class WealthServicesComponent {
    public readonly tabLinks: TabLinks = [
        { label: 'Comissões', link: 'commissions' },
    ];
}
